/**
 * @class
 * @classdesc Model for Owner on DB
 * * */
export default class Owner {
  /**
   *Constructor - sets a model for owner Data according to DB
   * @param {String} id
   * @param {String} name
   * @param {String} phoneNumber
   * @param {String} email
   * @param {String} password
   * @param {Boolean} verified
   * @param {Boolean} admin
   * @param {String} region
   * @param {String} zones
   * @param {Array.<Place>} places
   * @param {String} createdByOwnerId
   * @param {Boolean} canSeeClientsPersonalData
   * @param {String} lastLoginTime
   * @param {String} comments
   * @param {Array.<App>} apps
   */

  #OwnerObject = {}

  constructor(
    id,
    name,
    phoneNumber,
    email,
    password,
    verified,
    admin,
    region,
    zones,
    places,
    createdByOwnerId,
    canSeeClientsPersonalData,
    lastLoginTime,
    comments,
    apps
  ) {
    this.#OwnerObject.Id = id || 0
    this.#OwnerObject.Name = name || ''
    this.#OwnerObject.PhoneNumber = phoneNumber || ''
    this.#OwnerObject.Email = email || ''
    this.#OwnerObject.Password = password || ''
    this.#OwnerObject.Verified = verified || true
    this.#OwnerObject.Admin = admin || false
    this.#OwnerObject.Region = region || ''
    this.#OwnerObject.Zones = zones || ''
    this.#OwnerObject.Places = places || []
    this.#OwnerObject.CreatedByOwnerId = createdByOwnerId || 0
    this.#OwnerObject.CanSeeClientsPersonalData =
      canSeeClientsPersonalData || false
    this.#OwnerObject.LastLoginTime = this.getLastLoginTime()
    this.#OwnerObject.Comments = comments || ''
    this.#OwnerObject.Apps = apps || []
  }

  getLastLoginTime() {
    if (!this.lastLoginTime) {
      return '0001-01-01T00:00:00Z'
    }
    return this.lastLoginTime
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#OwnerObject
  }
}
